export default __webpack_public_path__ + "static/praguna-14b175b7905f0cd459882e346979a75d.png";